import { jsx as _jsx } from "react/jsx-runtime";
import { BanknotesIcon, CalendarDaysIcon, CalendarIcon, ChartBarIcon, ClockIcon, Cog6ToothIcon, CreditCardIcon, EyeIcon, EyeSlashIcon, FolderIcon, HomeIcon, InboxIcon, NewspaperIcon, NoSymbolIcon, PencilIcon, PencilSquareIcon, PresentationChartBarIcon, TagIcon, TrashIcon, UsersIcon, ChatBubbleLeftRightIcon, DocumentIcon, EllipsisVerticalIcon, Square3Stack3DIcon, XMarkIcon, ArrowTopRightOnSquareIcon, } from '@heroicons/react/24/outline';
import { ChatBubbleOvalLeftEllipsisIcon } from '@heroicons/react/16/solid';
import WhiteRightArrow from './Icons/WhiteRightArrow';
import BlackRightArrow from './Icons/BlackRightArrow';
import ChatBotIcon from './Icons/chatBotIcon';
import ChatsIcon from './Icons/chatsIcon';
import Upload from './Icons/upload';
import Trash from './Icons/trash';
import Bell from './Icons/bell';
import ChevronDown from './Icons/chevronDown';
import Alert from './Icons/alert';
import Logout from './Icons/logout';
import Settings from './Icons/settings';
import Check from './Icons/check';
import Error from './Icons/error';
import Send from './Icons/send';
import Copy from './Icons/copy';
import Pencil from './Icons/pencil';
import Smile from './Icons/smile';
import User from './Icons/user';
import NuraleLogo from './Icons/nuraleLogo';
import Lamp from './Icons/lamp';
import PlusIcon from './Icons/plusIcon';
import WarningIcon from './Icons/warning';
import ConnectionIcon from './Icons/connection';
import DisconnectionIcon from './Icons/disconnection';
import RefreshIcon from './Icons/refresh';
import BookIcon from './Icons/book';
import InfoIcon from './Icons/info';
import SearchDocumentIcon from './Icons/searchDocument';
import { cn } from '../../../lib/utils';
const IconSvg = ({ name, current, size = '6', iconColor = 'black', activeColor = 'white', hoverColor = 'white', className = '', }) => {
    const iconStyle = cn(current
        ? `text-${activeColor}-500`
        : `text-${iconColor}-300 group-hover:text-${hoverColor}-500`, `h-${size} w-${size} ${className}`);
    const Icons = {
        homeIcon: _jsx(HomeIcon, { className: iconStyle, "aria-hidden": "true" }),
        usersIcon: _jsx(UsersIcon, { className: iconStyle, "aria-hidden": "true" }),
        folderIcon: _jsx(FolderIcon, { className: iconStyle, "aria-hidden": "true" }),
        calendarIcon: _jsx(CalendarIcon, { className: iconStyle, "aria-hidden": "true" }),
        inboxIcon: _jsx(InboxIcon, { className: iconStyle, "aria-hidden": "true" }),
        chartBarIcon: _jsx(ChartBarIcon, { className: iconStyle, "aria-hidden": "true" }),
        settingsIcon: _jsx(Cog6ToothIcon, { className: iconStyle, "aria-hidden": "true" }),
        creditCardIcon: _jsx(CreditCardIcon, { className: iconStyle, "aria-hidden": "true" }),
        plusIcon: (_jsx(PlusIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        trashIcon: _jsx(TrashIcon, { className: iconStyle, "aria-hidden": "true" }),
        newspaperIcon: _jsx(NewspaperIcon, { className: iconStyle, "aria-hidden": "true" }),
        clockIcon: _jsx(ClockIcon, { className: iconStyle, "aria-hidden": "true" }),
        pencilIcon: _jsx(PencilIcon, { className: iconStyle, "aria-hidden": "true" }),
        pencilSquareIcon: (_jsx(PencilSquareIcon, { className: iconStyle, "aria-hidden": "true" })),
        eyeIcon: _jsx(EyeIcon, { className: iconStyle, "aria-hidden": "true" }),
        eyeSlashIcon: _jsx(EyeSlashIcon, { className: iconStyle, "aria-hidden": "true" }),
        tagIcon: _jsx(TagIcon, { className: iconStyle, "aria-hidden": "true" }),
        banknotesIcon: _jsx(BanknotesIcon, { className: iconStyle, "aria-hidden": "true" }),
        calendarDaysIcon: (_jsx(CalendarDaysIcon, { className: iconStyle, "aria-hidden": "true" })),
        noSymbolIcon: _jsx(NoSymbolIcon, { className: iconStyle, "aria-hidden": "true" }),
        presentationChartBar: (_jsx(PresentationChartBarIcon, { className: iconStyle, "aria-hidden": "true" })),
        chatBubbleLeftRightIcon: (_jsx(ChatBubbleLeftRightIcon, { className: iconStyle, "aria-hidden": "true" })),
        chatBubbleOvalLeftEllipsisIcon: (_jsx(ChatBubbleOvalLeftEllipsisIcon, { className: iconStyle, "aria-hidden": "true" })),
        document: _jsx(DocumentIcon, { className: iconStyle, "aria-hidden": "true" }),
        whiteRightArrow: (_jsx(WhiteRightArrow, { className: cn('w-6 h-2 my-0 mr-1', iconStyle) })),
        blackRightArrow: _jsx(BlackRightArrow, { className: iconStyle }),
        chatBotIcon: (_jsx(ChatBotIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        chatsIcon: _jsx(ChatsIcon, { className: iconStyle, "aria-hidden": "true" }),
        upload: _jsx(Upload, { className: iconStyle, "aria-hidden": "true" }),
        trash: _jsx(Trash, { className: iconStyle, "aria-hidden": "true" }),
        bell: _jsx(Bell, { className: iconStyle, "aria-hidden": "true" }),
        chevronDown: _jsx(ChevronDown, { className: iconStyle, "aria-hidden": "true" }),
        alert: _jsx(Alert, { className: iconStyle, "aria-hidden": "true" }),
        settings: _jsx(Settings, { className: iconStyle, "aria-hidden": "true" }),
        logout: (_jsx(Logout, { className: iconStyle, iconColor: iconColor, "aria-hidden": "true" })),
        check: _jsx(Check, { className: iconStyle, "aria-hidden": "true" }),
        error: _jsx(Error, { className: iconStyle, "aria-hidden": "true" }),
        send: _jsx(Send, { className: iconStyle, "aria-hidden": "true" }),
        copy: _jsx(Copy, { className: iconStyle, "aria-hidden": "true" }),
        lamp: _jsx(Lamp, { className: iconStyle, "aria-hidden": "true" }),
        smile: _jsx(Smile, { className: iconStyle, "aria-hidden": "true" }),
        nuraleLogo: _jsx(NuraleLogo, { className: iconStyle, "aria-hidden": "true" }),
        pencil: _jsx(Pencil, { className: iconStyle, "aria-hidden": "true" }),
        ellipsisVertical: (_jsx(EllipsisVerticalIcon, { className: iconStyle, "aria-hidden": "true" })),
        square3d: _jsx(Square3Stack3DIcon, { className: iconStyle, "aria-hidden": "true" }),
        user: (_jsx(User, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        xMarkIcon: _jsx(XMarkIcon, { className: iconStyle, "aria-hidden": "true" }),
        arrowTopRightOnSquareIcon: (_jsx(ArrowTopRightOnSquareIcon, { className: iconStyle, "aria-hidden": "true" })),
        warningIcon: (_jsx(WarningIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        connectionIcon: (_jsx(ConnectionIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        disconnectionIcon: (_jsx(DisconnectionIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        refreshIcon: (_jsx(RefreshIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        bookIcon: (_jsx(BookIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        infoIcon: (_jsx(InfoIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
        searchDocument: (_jsx(SearchDocumentIcon, { className: iconStyle, "aria-hidden": "true", iconColor: iconColor })),
    };
    return Icons[name];
};
export default IconSvg;
//# sourceMappingURL=index.js.map